export const askTelQuestionErrorHandler = (error: string): string => {
  let errorMsg = "Maximum upload size exceeded";
  if (error && error.length > 200 && error.includes(errorMsg)) return errorMsg;
  return error;
};
